<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-07-14 15:36:14
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2024-01-18 11:49:22
 * @FilePath: \jsczt_vue\src\components\bmDialog .vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="dialog">
      <div class="content_right">
        <div class="showCont"  :style="{ zoom: scaleb }" >
          <div class="close" @click="handlClose">x</div>
          <div class="listf">
            <ul v-if="bmoptions.length>0">
              <li v-for="item in bmoptions" :key="item.channelid">
                <span :class="{ 'active': activeItem === item.chnldesc}" @click="getdata(item)">{{ item.chnldesc }}</span>
              </li>
            </ul>
            <ul v-else>
              <li>
                暂无数据
              </li>
            </ul>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'bmDialog',
  props: {
    bmoptions: {
      type: Array
    }
  },
  data () {
    return {
      activeItem: '',
      scaleb: 1 // 初始缩放比例
    }
  },
  computed: {
    getWindowSizeb () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  watch: {
    scaleb: {
      handler (val) {
        window.addEventListener('load', this.handleResizeb)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResizeb()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResizeb)
    window.addEventListener('resize', this.handleResizeb)
  },
  methods: {
    handleResizeb () {
      var width = this.getWindowSizeb.width
      // 假设你设计稿的宽度是 1920PX
      var designWidth = 1920
      var scale = width / designWidth
      this.scaleb = scale.toFixed(2)
    },
    handlClose () {
      this.$emit('close', true)
    },
    getdata (data) {
      this.activeItem = data.chnldesc
      this.$emit('curtext', data)
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
}
ul li {
  list-style: none;
}
/* .dialog{
  position: fixed;
  top: 390PX;
  left: 28vw;
  z-index: 999;
} */
.showCont{
  position: absolute;
  width: 1100PX;
  height: 480PX;
  background: #FEFDFD;
  box-shadow: 0PX 0PX 9PX 0PX rgba(24,33,65,0.09);
  border-radius: 20PX;
  padding: 40PX 0 20PX 0PX;
  color: #686868;
}
.listf {
  width: 1050PX;
  height: 420PX;
  padding-top: 10PX;
  padding-right: 23PX;
  padding-bottom: 20PX;
  cursor: pointer;
  margin-left: 18PX;
  overflow: auto;
}
.listf ul li {
  width: 330PX;
  height: 55PX;
  display: inline-block;
  margin-left: 10PX;
  font-size: 16PX;
  font-weight: 400;
  color: #161616;
  vertical-align: top;
}
.texts{
  font-size: 18PX;
  font-weight: 400;
  color: #e6c69c;
}
.active{
  color: #e6c69c !important;
}
.close{
  position: absolute;
  font-size: 20PX;
  top: 0PX;
  right: 14PX;
  cursor: pointer;
  font-size: 24PX;
}
</style>



// WEBPACK FOOTER //
// src/components/bmDialog .vue